<template>
    <div>
        <template v-if="indumentarias">
            <b-card-text class="mt-3">
                <h6>- Recogidas</h6>
                <h6 class="pl-4">- Cantidad: <span class="red">{{ indumentarias.recogidas }} unidades</span></h6>
            </b-card-text>
            <b-card-text class="mt-3">
                <h6>- Sin recoger</h6>
                <h6 class="pl-4">- Cantidad: <span class="red">{{ indumentarias.sin_recoger }} unidades</span></h6>
            </b-card-text>
        </template>
        <LoaderComponent v-else/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                indumentarias: null
            }
        },
        methods: {
            getIndumentariasRecogidas() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.inventario.recogidas'), params).then(res => {
                    this.indumentarias = res.data.estado;
                }).finally(() => this.loading = false);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            } 
        },
        created() {
            this.getIndumentariasRecogidas();
        }
    }
</script>